import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import productReducer from "./product/productReducer";
import gradeReducer from "./grade/gradeReducer";
import subjectReducer from "./subject/subjectReducer";
import userReducer from "./user/userReducer";
import singleSimPageReducer from "./singleSimPage/singleSimPageReducer";
import singleSimDetailReducer from "./singleSimDetail/singleSimDetailReducer";
import cartReducer from "./cart/cartReducer";
import companyReducer from "./cart/companyReducer";
import loginReducer from "./login/loginReducer";
import constantReducer from "./constant/constantReducer";
import hashtagReducer from "./hashtag/hashtagReducer";
import userMessageReducer from "./userMessage/userMessageReducer";
import alertReducer from "./alert/alertReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userDetail", "companyDetail", "constantsDetail", "userMessage"],
};

const rootReducer = combineReducers({
  productDetail: productReducer,
  subjectDetail: subjectReducer,
  gradeDetail: gradeReducer,
  userDetail: userReducer,
  singleSimPageDetail: singleSimPageReducer,
  singleSimDetail: singleSimDetailReducer,
  cartDetail: cartReducer,
  companyDetail: companyReducer,
  loginDetail: loginReducer,
  constantsDetail: constantReducer,
  hashtagDetail: hashtagReducer,
  userMessage: userMessageReducer,
  alert: alertReducer,
});
export default persistReducer(persistConfig, rootReducer);
